// extracted by mini-css-extract-plugin
module.exports = {"show-xs":"index_show-xs_1_2Xc","hide-xs":"index_hide-xs_3aSsf","dropdown":"index_dropdown_2op-z","avatar":"index_avatar_3NJPx","menuIcon":"index_menuIcon_3J_bl"};